import React from "react";
import { Link } from "react-router-dom";

const NeedCategoryCard = ({ category }) => {
  return (
    <>
      <Link to={`needs/${category.id}`}>
        <div
          className="master-need-category-card"
          style={{ background: category.indicator }}
        >
          {category.name}
        </div>
      </Link>
    </>
  );
};

export default NeedCategoryCard;
